import _         from 'lodash'
import Immutable from 'immutable';
import GroupMenu from './group_menu';

export default class GroupMenuWithOrders extends GroupMenu {
  isSaved() {
    return this._courseMenus.every(courseMenu => courseMenu.isSaved());
  }

  hasSelection() {
    return this._courseMenus.some(courseMenu => courseMenu.hasSelection());
  }

  isLocked() {
    return this.isAfterDeadline() || this.selectionForOtherCanteensExists();
  }

  ordersForOtherCanteensExist() {
    if (_.isNil(this.__ordersForOtherCanteensExist)) {
      this.__ordersForOtherCanteensExist = this._menu
        .groupMenusForCanteens(this.date, this.group)
        .delete(this.canteen.id)
        .some(groupMenu => groupMenu.hasOrders());
    }

    return this.__ordersForOtherCanteensExist;
  }

  selectionForOtherCanteensExists() {
    if (_.isNil(this.__selectionForOtherCanteensExists)) {
      this.__selectionForOtherCanteensExists = this._menu
        .groupMenusForCanteens(this.date, this.group)
        .delete(this.canteen.id)
        .some(groupMenu => groupMenu.hasSelection());
    }

    return this.__selectionForOtherCanteensExists;
  }

  hasOrders() {
    return this._courseMenus.some(courseMenu => !_.isNil(courseMenu.savedMealNumber));
  }

  orders() {
    if (this._courseMenus) {
      return this._courseMenus
        .filter(courseMenu => (!courseMenu.isSaved()) || courseMenu.hasSelection())
        .map((courseMenu, courseName) => ({
          course: courseName,
          number: courseMenu.selectedMealNumber,
        }))
        .valueSeq().toArray();
    } else {
      return [];
    }
  }

  allAdditionalMealsSelected() {
    if (_.isNil(this.__allAdditionalMealsSelected)) {
      const selectedMeals = this.selectedMeals();

      this.__allAdditionalMealsSelected = selectedMeals.every(mainMeal =>
        !mainMeal.hasAdditional() || selectedMeals.some(
          additionalMeal => additionalMeal.courseName === mainMeal.additionalCourseName
        )
      );
    }

    return this.__allAdditionalMealsSelected;
  }

  selectedMeals() {
    if (this._courseMenus) {
      return this.constructor.selectedMeals(this._courseMenus);
    } else {
      return new Immutable.List;
    }
  }

  static selectedMeals(courseMenus) {
    return courseMenus
      .filter(cm => cm.selectedMealNumber)
      .map(   cm => cm.meals.find(meal => meal.number === cm.selectedMealNumber))
      .valueSeq();
  }
}
